import React from 'react';
import { Modal, Icon, Button, Text, Dialog } from '@ui-component-library';

/**
 * Shows Naturvårdsverket WMS GetFeatureInfo — layer names (hits) only, not full attribute rows.
 * @param {HTMLElement} [container] — Portal target; use the map wrapper so the modal appears above the map in browser fullscreen (top layer).
 */
export const AuctionWmsIdentifyModal =({ show, loading, sections, onHide, container }) =>{
    return (
        <Dialog
            isOpen={show}
            size="medium"
        >
            <Dialog.Header className="items-start border-0" >
                <Text variant="text-lg/leading-normal/medium" className="mb-0 flex-1 pr-2">
                    Skyddad natur (Naturvårdsverket)
                </Text>
                <Button variant="tertiary" size="icon" onClick={onHide} aria-label="Stäng">
                    <Icon name="CrossSimple" className="color-charcoal-500" size="medium" />
                </Button>
            </Dialog.Header>
            <Dialog.Content className="py-3 min-h-[300px] flex items-center justify-center">
            {loading ? (
                    <div className="flex flex-col align-center justify-center py-4 gap-3 w-full h-full">
                        <Icon name="Loader" size="large" className="animate-spin text-charcoal-500" />
                        <span className="fs-6 text-center">Hämtar information från kartlagren…</span>
                    </div>
                ) : !sections || sections.length === 0 ? (
                    <p className="mb-0 fs-6">Ingen information hittades för denna punkt i de valda lagren.</p>
                ) : (
                    <div className="text-start">
                        {sections.map((s, idx) => (
                            <div key={`${s.label}-${idx}`} className="font-bold caption mb-2">
                                {s.label}
                            </div>
                        ))}
                    </div>
                )}
            </Dialog.Content>
            <Dialog.Footer className="justify-end border-0">
                <Button variant="primary" className="w-full md:w-auto" onClick={onHide}>
                    Stäng
                </Button>
            </Dialog.Footer>
        </Dialog>
    );
}
